import Icon from "@mui/icons-material/VolunteerActivismTwoTone";
import { YearlyNiyaazList } from "./YearlyNiyaazList";
import { YearlyNiyaazCreate } from "./YearlyNiyaazCreate";
import { YearlyNiyaazEdit } from "./YearlyNiyaazEdit";
import { YearlyNiyaazShow } from "./YearlyNiyaazShow";

export default {
  list: YearlyNiyaazList,
  create: YearlyNiyaazCreate,
  edit: YearlyNiyaazEdit,
  show: YearlyNiyaazShow,
  icon: Icon,
  label: "Yearly Niyaaz",
  options: { label: "Yearly Niyaaz" },
  name: "yearlyNiyaaz",
};
